import React from 'react'
import './styles/home.scss';
import Home from "./containers/Home";

import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import FlatIllustration from './containers/FlatIllustration';
import Designs from './containers/Designs';
import CustomCursor from './components/CustomCursor';
import ContactMe from './containers/ContactMe';
import AboutMe from './containers/AboutMe';
import SmudegArts from './containers/SmudegArts';

function App() {
    return (
        <>
            <CustomCursor />
            <Router>
                <Switch>
                    <Route exact path={'/'} component={Home} />
                    <Route exact path={'/flat-illustration'} component={FlatIllustration} />
                    <Route exact path={'/smudge-arts'} component={SmudegArts} />
                    <Route exact path={'/designs'} component={Designs} />
                    <Route exact path={'/about-me'} component={AboutMe} />
                    <Route exact path={'/contact-me'} component={ContactMe} />
                </Switch>
            </Router>
        </>
    );
}

export default App;
